export const ACTIVE_ELEMENT_TYPES = {
	Component: 'Component',
	BranchSelector: 'BranchSelector',
	Add: 'Add',
	MergeIcon: 'MergeIcon',
	Search: 'Search', 
	LoopAdd: 'LoopAdd',
	LoopEnd: 'LoopEnd'
};


// WEBPACK FOOTER //
// ./source/ts/constants/component-types.ts